import React from 'react';
import { FormattedMessage } from 'react-intl';

const NotFound = () => (
  <div className="not-found-page">
    <h1>
      <FormattedMessage id="error.page.notFound.title" />
    </h1>
    <p>
      <FormattedMessage id="error.page.notFound.description" />
    </p>
  </div>
);

export default NotFound;
